import React, { useEffect, useState } from 'react'

import { EuiPanel } from '@elastic/eui'

import { calculateDistance } from 'utils/mapUtils'

import { BillboardGeo, GeoPoint } from '../../../api/interfaces'
import { useGetBillboardGeosQuery } from '../../../api/rtkQueryApi/platform/audiencesApi'
import { useDebounceEffect } from '../../../utils/useDebounceEffect'
import { MapBoxContainer } from '../../mapBox/MapBoxContainer'
import { useMapBox } from '../../mapBox/useMapBox'

export interface IBillboardFinderV2 {
  search?: string
}

export const BillboardFinderV2: React.FC<IBillboardFinderV2> = props => {
  const { mapContainerRef, initializeMap, center, setMarkers, flyTo, searchPlace, isReady, isLoading, hasError, error } = useMapBox()
  const [billboards, setBillboards] = useState<BillboardGeo[]>([])
  const [searchCenter, setSearchCenter] = useState<GeoPoint>({ lng: -98.5795, lat: 39.8283 })
  const radiusSearch = 20000000
  const radiusDifToSearch = 16000000

  const getBillboardQuery = useGetBillboardGeosQuery({
    lat: searchCenter.lat,
    lng: searchCenter.lng,
    radiusMeters: radiusSearch
  })

  useDebounceEffect(
    1000,
    () => {
      if (center && calculateDistance(center, searchCenter) > radiusDifToSearch) {
        setSearchCenter(center)
      }
    },
    [center, searchCenter]
  )

  useDebounceEffect(
    400,
    () => {
      if (!props.search || !isReady) {
        return
      }
      searchPlace(props.search).then(response => {
        flyTo(response.features[0].geometry.coordinates, 11)
      })
    },
    [props.search, isReady]
  )

  useEffect(() => {
    if (!getBillboardQuery?.data || !isReady) {
      return
    }
    setBillboards(getBillboardQuery.data ?? [])
  }, [getBillboardQuery.data, isReady])

  useEffect(() => {
    if (!isReady) {
      return
    }
    const bbMarkers = billboards.map(billboard => ({ lat: billboard.latitude, lng: billboard.longitude }))
    setMarkers(bbMarkers)
  }, [billboards, setMarkers, isReady])

  return (
    <EuiPanel hasBorder={false} hasShadow={false} style={{ height: 400 }}>
      <MapBoxContainer mapContainerRef={mapContainerRef} initializeMap={initializeMap} isReady={isReady} isLoading={isLoading} hasError={hasError} error={error} />
    </EuiPanel>
  )
}
